/**
 * Use Case: Fetch Voucher Categories Dropdown
 * Business logic for fetching the list of voucher categories for dropdown selection.
 */

import type { VoucherCategoryDropdownItem } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch the list of voucher categories for dropdown selection
 */
export const FetchVoucherCategoriesDropdownUseCase = async (): Promise<
  readonly VoucherCategoryDropdownItem[]
> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchVoucherCategoriesDropdown();
};

